import _ from 'lodash';
import { getMentionIds } from "Source/util/conversations";
import { addComment, updateComment, deleteComment } from "Source/api/comments";

export const addDocumentComment = ({
    commentStr, 
    document, 
    projectId, 
    loggedUser, 
    replyTo,
    source= null,
}) => {
    const params = {
        filter: { 
            seen: 0 
        },
        data: { 
            comment: commentStr, 
            linkType: "document", 
            linkId: document.id, 
            usersId: loggedUser.data.id 
        },
        document: document.origin,
        projectId: projectId,
        userId: loggedUser.data.id,
        username: loggedUser.data.username,
        reminderList: _.union(getMentionIds(commentStr)),
        ...(source) && {...source},
    };


    const replyingParams = {
        type: "reply",
        commentGroup: replyTo
    }

    const postParams = {
        ...params, 
        ...replyTo 
            ? replyingParams 
            : {}
    };

    return addComment(postParams);
}


export const updateDocumentComment = async({commentId, commentStr, source}) => {
    const params = {
        comment: `${commentStr}`,
        ...(source) && {source: source},
    }

    return updateComment(commentId, params)
}

export const deleteDocumentComment = async(commentId) => {
    return deleteComment(commentId)
}